export default __webpack_public_path__ + "static/media/mentoriaDerechos.a1bb728a.png";